module.exports = __webpack_public_path__ + "img/instructor-active.02a1acd4.svg";